import type { DeepPartial } from '@apollo/client/utilities'
import { PaginatedPropertyKey, PageInfo } from '../typings'

export const getPageInfo = <
  TData extends object,
  TPaginationProperty extends PaginatedPropertyKey<TData>
>(
  data: TData | DeepPartial<TData> | null | undefined,
  propertyName: TPaginationProperty
): PageInfo => {
  const dataRecord: Partial<
    Record<
      TPaginationProperty,
      { pageInfo?: DeepPartial<PageInfo> | null } | null
    >
  > = data ?? {}
  const pageInfo = dataRecord[propertyName]?.pageInfo

  if (pageInfo && typeof pageInfo.hasNextPage === 'boolean') {
    return {
      hasNextPage: pageInfo.hasNextPage,
      endCursor:
        typeof pageInfo.endCursor === 'string' ? pageInfo.endCursor : null
    }
  }

  return {
    endCursor: null,
    hasNextPage: false
  }
}
